import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import './ButtonIcon.scss';

export const ButtonIcon = ({
  onClick,
  icon,
  className = '',
  size = 'sm',
  ariaLabel
}: {
  onClick: () => void;
  icon: IconProp;
  className?: string;
  size?:
    | '2xs'
    | 'xs'
    | 'sm'
    | 'lg'
    | 'xl'
    | '2xl'
    | '1x'
    | '2x'
    | '3x'
    | '4x'
    | '5x'
    | '6x'
    | '7x'
    | '8x'
    | '9x'
    | '10x';
  ariaLabel?: string;
}) => {
  return (
    <button
      type='button'
      className={`button-icon ${className}`}
      onClick={onClick}
      aria-label={ariaLabel}>
      <FontAwesomeIcon icon={icon} size={size} onClick={onClick} />
    </button>
  );
};
